import React, { useEffect, useState } from 'react';
import profileImg from '../resources/Profile.jpg';
const Header = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/header.json')
      .then(res => {
        if (!res.ok) throw new Error('Failed to load header data');
        return res.json();
      })
      .then(setData)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <header className="resume-header"><p>Loading...</p></header>;
  if (error) return <header className="resume-header"><p>Error: {error}</p></header>;
  if (!data) return null;

  return (
    <header className="resume-header">
      <div className="header-flex" style={{alignItems: 'center', gap: '24px'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '24px'}}>
          <img src={profileImg} alt={data.name} className="profile-photo" />
          <div className="header-content">
            <h1>{data.name}</h1>
            <h2>{data.title}</h2>
            <span>Location: {data.location}</span>
           </div>
        </div>
            <div className="contact-info">
            {data.summary.map((resp, rIdx) => (
              <p key={rIdx}>{resp}</p>
            ))}
            </div>
            
      </div>
    </header>
  );
};

export default Header;
